import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  profileImageSelector,
  getLoginDetails,
  profileSelector,
  getLanguageSelector,
} from '../../../selectors'
import '../../../styles/userDetail.css'
import UserImage from 'custom/assets/dashboard/dummy-user.png'
import { DIALOG_KEYS, LANDING_KEYS } from '../../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import { useCallback } from 'react'
import { setAppLanguage } from '../../../actions'
import config from 'custom/config/environment'

export default function UserDetail() {
  const profile = useSelector(profileSelector)
  const image = useSelector(profileImageSelector)
  const loginDetails = useSelector(getLoginDetails)
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const selectedLng = useSelector(getLanguageSelector)

  function formatTime(dt) {
    let hours = new Date(dt).getHours()
    let minutes = new Date(dt).getMinutes()
    const time = hours >= 12 ? 'pm' : 'am'
    hours %= 12
    hours = hours || 12 // the hour '0' should be '12'
    minutes = minutes < 10 ? `0${minutes}` : minutes
    const strTime = `${hours}:${minutes} ${time}`
    return strTime
  }
  function formatDate(dt) {
    let d = new Date(dt).getDate()
    let s = 'th'
    switch (d) {
      case '01':
      case '11':
      case '21':
      case '31':
        s = 'st'
        break
      case '02':
      case '12':
      case '22':
        s = 'nd'
        break
      case '03':
      case '13':
      case '33':
        s = 'rd'
        break
    }
    let m = new Date(dt).toDateString().split(' ', 3)[1]
    let y = new Date(dt).getFullYear().toString().slice(2, 4)
    const strDate = `${d}${s} ${m}'${y}`
    return strDate
  }

  const handleLanguage = useCallback((e) => {
    try {
      const { value } = e.target
      dispatch(setAppLanguage(value))
      i18next.changeLanguage(value)
    } catch (err) {}
  }, [])

  return (
    <React.Fragment>
      <div className='d-flex justify-content-between'>
        <div className=''>
          <div className='d-inline-block mr-2'>
            {image !== null && (
              <img
                className='rounded-circle'
                src={`data:image/png;base64, ${image && (image.imageData || image)}`}
                alt='user image'
                height='40'
                width='40'
              />
            )}
            {image === null && (
              <img
                className='rounded-circle'
                src={UserImage}
                alt='user image'
                height='40'
                width='40'
              />
            )}
          </div>
          <div className='d-inline-block font-weight-600'>
          {t(LANDING_KEYS.HI)}, {profile?.firstName} {profile?.lastName}
          </div>
        </div>

        <div className='text-right login-text font-weight-600'>
          <div>{t(DIALOG_KEYS.LAST_LOGIN)}</div>
          <div>
            {formatDate(loginDetails?.lastLoginTime)}
            <span className='ml-2'>{formatTime(loginDetails?.lastLoginTime)}</span>
          </div>
          {config.LANGUAGE_SELECTION && (
            <div className='language-selection-dashboard'>
              <select onChange={handleLanguage} value={selectedLng} placeholder='Choose Language'>
                {config.LANGUAGE_LIST.map((option, index) => (
                  <option value={option} key={index}>
                    {option.toLocaleUpperCase()}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      </div>

      <div className='font-weight-600 mt-4'>{t(DIALOG_KEYS.INFORMATION)}</div>
    </React.Fragment>
  )
}
